import { generatePath } from "react-router-dom";
import { ARTICLE_DASHBOARD } from "../apiEndPoints";
import { api, convertKeysToCamelCase } from "./api";

export const dashboardApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getDashboard: builder.query({
      query: ({ accountId, timezone }) => ({
        url:
          generatePath(ARTICLE_DASHBOARD, { accountId }) +
          `?timezone=${timezone}`,
        method: "GET",
      }),
      transformResponse: (response) => convertKeysToCamelCase(response),
      providesTags: ["Dashboard"],
    }),
  }),
});

export const { useGetDashboardQuery } = dashboardApiSlice;
